import { QuestionBase } from './question-base.model';

export class TextareaQuestion extends QuestionBase<string> {
   controlType = 'textarea';
   type: string;
   pattern: string;
   disabled: boolean;
   visible: string;
   formAutofill: any;
   macro_datasource: any;
   maxlength: any;
   rows: any;
   minlength: any;
   placeholder: string = '';
   additional_space: boolean;

   constructor(options: {} = {}) {
      super(options);
      this.type = options['type'] || '';
      this.pattern = options['pattern'] || '';
      this.placeholder = options['placeholder'] || '';
      this.maxlength = options['maxlength'] || '';
      this.minlength = options['minlength'] || '';
      this.macro_datasource = (options['macro_datasource'] == undefined) ? false : options['macro_datasource'];
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.disabled = options['disabled'] || false;
      this.formAutofill = options['formAutofill'];
      this.rows = options['rows'] || 2;
      this.additional_space = (options['additional_space'] == undefined) ? false : options['additional_space'];
   }
}